import type { Activity, Enrollment, Payment } from '../types/GrooverTypes'
import { isWalkInPayment } from './isWalkInPayment'
import { sumWalkInRefundedCents } from './sumWalkInRefundedCents'

export type WalkInReceiptItem = {
  enrollment: Enrollment
  payment: Payment
  activity: Activity
  quantity: number
  refundedCents: number
}

/**
 * Flatten enrollments into one WalkInReceiptItem per walk-in Swish payment.
 * Refund entries are excluded from items but their total is reflected in `refundedCents`.
 */
export function getWalkInReceiptItems(enrollments: Enrollment[]): WalkInReceiptItem[] {
  const items: WalkInReceiptItem[] = []
  for (const enrollment of enrollments) {
    const activity = enrollment.activities?.[0]
    if (!activity) continue
    for (const payment of enrollment.payments ?? []) {
      if (!isWalkInPayment(payment)) continue
      const quantity = enrollment.activityQuantities?.[activity.id] ?? 1
      const refundedCents = payment.paymentRef ? sumWalkInRefundedCents(enrollment, payment.paymentRef) : 0
      items.push({ enrollment, payment, activity, quantity, refundedCents })
    }
  }
  return items
}
